// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"b76f6481","805":"6b8b1ef2"}[chunkId] + ".chunk.css";
};